export default __webpack_public_path__ + "static/media/About Us - Banner 3.641a2c4f.jpg";